import React, { useEffect, useContext, useMemo } from 'react'
import * as classes from './Founders.module.scss'
import cn from 'classnames'
import Container from '../../../../ui/Container/Container'
import { deleteHtmlTag } from '../../../../../utils/deleteHtmlTag'
import { FormContext } from '../../../../../context'
import { startAnimationScroll } from '../../../../../utils/animations'
import splitTitleV2 from '../../../../../utils/splitTitleV2'

function Founders({ data, lang }) {
    const { animationStart } = useContext(FormContext)

    const content = useMemo(
        () => [
            {
                name: deleteHtmlTag(data.blockLeft.value, 'p'),
                photo: data.blockLeft.photo.url,
                description: data.blockLeft.description
            },
            {
                name: deleteHtmlTag(data.blockRight.value, 'p'),
                photo: data.blockRight.photo.url,
                description: data.blockRight.description
            }
        ],
        []
    )

    const classAnimationTitle = 'anime-title-founders'

    useEffect(() => {
        if (animationStart) {
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([{ type: 'title', className: classAnimationTitle }])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    if (!content || !content.length) {
        return null
    }

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <Container>
                <div className={classes.Items}>
                    {content.map((item, index) => (
                        <div className={classes.Item} key={index}>
                            {item.photo ? <div className={classes.ItemImg} style={{ backgroundImage: `url(${item.photo})` }} /> : null}

                            <div className={classes.Card}>
                                <span className={classes.Dash} />

                                {item.name ? (
                                    <p
                                        className={`${classes.ItemTitle} ${classAnimationTitle}`}
                                        dangerouslySetInnerHTML={{ __html: item.name }}
                                    />
                                ) : null}

                                {item.description ? (
                                    <p className={classes.ItemText} dangerouslySetInnerHTML={{ __html: item.description }} />
                                ) : null}
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}

export default Founders
